<template>
 <div class="card-primary">
            <p class="text-xxl text-bold">Recent Issues</p>

            <div class="row mt-20">
              <div class="col-12 text-bold">
                <div class="card-primary-scroll-small">
                  <div class="card-issues" v-for="issueProject in issue" :key="issueProject.id">
                    <div class="" v-if="issueProject.closed_on == null ">
                        <div v-bind:class="'card-'+issueProject.priority.name.toLowerCase()">
                          <div class="row">
                            <div class="col-1" v-bind:class="'icon-'+issueProject.priority.name.toLowerCase()">
                              <i class="fas fa-angle-down fa-2x" v-if="issueProject.priority.name.toLowerCase() == 'low'"></i>
                              <i class="fas fa-grip-lines fa-2x" v-else-if="issueProject.priority.name.toLowerCase() == 'normal'"></i>
                              <i class="fas fa-angle-up fa-2x" v-else-if="issueProject.priority.name.toLowerCase() == 'high'"></i>
                              <i class="fas fa-angle-double-up fa-2x" v-else-if="issueProject.priority.name.toLowerCase() == 'urgent'"></i>
                              <i class="fas fa-caret-square-up fa-2x" v-else></i>
                            </div>
                            <div class="col-2 text-m text-blur">{{issueProject.priority.name}}</div>
                            <div class="col-6">
                              <p class="text-m">{{ issueProject.subject}}</p>
                            </div>
                            <div class="col-3" v-if="issueProject.assigned_to != null ">
                              <p class="text-m text-blur">{{issueProject.assigned_to.name}}</p>
                            </div>
                            <div class="col-3" v-else>
                              <p class="text-m text-blur">-</p>
                            </div>
                          </div>

                        </div>
                    
                    </div>
                    
                  </div>
                </div>

              </div>
            </div>

          </div>    
</template>

<script>
export default {
    name:"CardOpenIssue",
    props: ['issue']
}
</script>

<style scoped>
  .text-blur{
    color:#616161 !important
  }

  .text-m {
    font-weight: 700;
  }
  .card-primary-scroll-small {
    height: 560px;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/Home/CardOpenIssue.vue